"use strict";

exports.__esModule = true;
exports.DIDWeb3Name = void 0;
var _api = require("@polkadot/api");
var _rxjs = require("rxjs");
const ENDPOINTS = ['wss://spiritnet.kilt.io/', 'wss://spiritnet.api.onfinality.io/public-ws'];
class DIDWeb3Name {
  constructor() {
    this.api = void 0;
    this.cached = void 0;
    const provider = new _api.WsProvider(ENDPOINTS, false);
    this.api = new _api.ApiPromise({
      provider
    });
    this.cached = {};
  }
  async getName(address) {
    if (this.cached[address]) return this.cached[address];

    // check is connected first
    await this.api.isReady;
    const connectedDid = await this.api.query.didLookup.connectedDids(address);
    if (connectedDid.isSome) {
      var _connectedDid$unwrap, _connectedDid$unwrap$;
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
      const didAccount = (_connectedDid$unwrap = connectedDid.unwrap()) === null || _connectedDid$unwrap === void 0 ? void 0 : (_connectedDid$unwrap$ = _connectedDid$unwrap.did) === null || _connectedDid$unwrap$ === void 0 ? void 0 : _connectedDid$unwrap$.toString();
      const web3name = await this.api.query.web3Names.names(didAccount);
      if (web3name.isSome) {
        const name = web3name.unwrap().toUtf8();
        this.cached[address] = name;
        return name;
      }
    }
    return undefined;
  }
  subscribeName(address) {
    return (0, _rxjs.of)(this.getName(address));
  }
}
exports.DIDWeb3Name = DIDWeb3Name;